<template>
    <div class="invoiceRecord">
        <lazy-load-list :getData="initData" :description="'暂无记录'" :query="query">
            <template v-slot="slotData">
                <div class="record-list">
                    <div class="record-item" v-for="(item, index) in slotData.dataList" :key="index">
                        <div class="record-item-header flex align-center">
                            <img src="@/assets/images/invocie/invoice-record-item.png" alt="" />
                            <p class="record-item-date">{{ item.updateTime }} {{ parseDateToWeek(item.updateTime) }}</p>
                            <p :class="['record-item-status', item.status == 1 ? 'record-item-status1' : item.status == 0 ? 'record-item-status2' : item.status == 2 ? 'record-item-status3' : item.status == 3 ? 'record-item-status1' : '']">
                                {{ item.status == 1 ? "已开票" : item.status == 0 ? "待开票" : item.status == 2 ? "开票失败" : item.status == 3 ? "补录开票" : "" }}
                            </p>
                        </div>
                        <div class="record-item-content flex align-center justify-between">
                            <div class="record-item-left">
                                <div class="record-item-left-item">
                                    <div class="record-item-left-item-content align-center" @click="toInvoiceDetail(item)">
                                        <div>{{ item.content }}</div>
                                        <div></div>
                                        <div>{{ item.parkName }}</div>
                                        <!-- <van-tag style="padding:2px 8px;border-radius:6px;" plain type="primary">电子发票</van-tag> -->
                                    </div>
                                </div>
                            </div>
                            <div class="record-item-right flex-column">
                                <span class="record-item-price text-price">{{ item.money }}</span>
                                <van-button class="record-item-right-btn" @click="resend(item)" color="#009AF3 " v-if="item.status != 2">重发发票</van-button>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </lazy-load-list>
    </div>
</template>

<script>
import { parseDateToWeek } from "@/libs/parseData";
import { listElectronicInvoice } from "@/api/index";

import LazyLoadList from "@/components/base/lazyLoadList/lazy-load-list.vue";

export default {
    name: "InvoiceRecord",
    components: {
        LazyLoadList,
    },
    data() {
        return {
            query: {
                page: 0,
                pageSize: 10,
            },
        };
    },
    mounted() {},
    methods: {
        parseDateToWeek,
        //给子组件使用
        initData() {
            return listElectronicInvoice(this.query);
        },

        // 开票详情
        toInvoiceDetail(item) {
            this.$router.push({
                name: "InvoiceDetail",
                params: item,
            });
        },
        // 开票成功 重发发票
        resend(item) {
            let obj = {
                invoiceNo: item.invoiceNo,
                invoiceOrder: item.invoiceOrder,
            };
            this.$router.push({ name: "InvoiceResend", params: obj });
        },
    },
};
</script>

<style lang="less" scoped>
@import "~@/assets/style/base.less";
@import "~@/assets/style/color.less";
.invoiceRecord {
    .record-list {
        .record-item {
            background-color: #fff;
            padding: 0 30px;
            margin-bottom: 15px;
            .record-item-header {
                padding: 30px 0;
                border-bottom: @comboder;
                img {
                    width: 32px;
                    height: 32px;
                }
                .record-item-date {
                    font-size: 28px;
                    color: #666666;
                    margin-left: 16px;
                }
                .record-item-status {
                    margin-left: auto;
                    font-size: 28px;
                }
                .record-item-status1 {
                    color: @main-color;
                }
                .record-item-status2 {
                    color: #f76a2d;
                }
                .record-item-status3 {
                    color: #f72d2d;
                }
            }
            .record-item-content {
                padding: 30px 0;
                .record-item-left {
                    .record-item-left-item {
                        min-width: 300px;
                        .record-item-left-item-content {
                            font-size: 32px;
                            color: #666666;
                            span {
                                margin-right: 10px;
                            }
                        }
                    }
                }
                .record-item-right {
                    text-align: right;
                    .record-item-price {
                        font-size: 48px;
                        font-weight: bold;
                        color: #333333;
                    }
                    .record-item-right-btn {
                        width: 138px;
                        height: 48px;
                        white-space: nowrap;
                        font-size: 24px;
                        background: #009af3;
                        border-radius: 8px;
                        margin-top: 32px;
                    }
                }
            }
        }
    }
}
</style>
